
import { Service, User, Appointment, Product, FinanceTransaction } from './types';

export const MOCK_SERVICES: Service[] = [
  { id: 's1', name: 'Стрижка и укладка', durationMin: 60, price: 2500, color: 'bg-purple-100 text-purple-700', category: 'Волосы' },
  { id: 's2', name: 'Маникюр комплекс', durationMin: 90, price: 1800, color: 'bg-pink-100 text-pink-700', category: 'Ногти' },
  { id: 's3', name: 'Окрашивание волос', durationMin: 120, price: 5000, color: 'bg-blue-100 text-blue-700', category: 'Волосы' },
  { id: 's4', name: 'Коррекция бровей', durationMin: 30, price: 800, color: 'bg-teal-100 text-teal-700', category: 'Лицо' },
  { id: 's5', name: 'Уход за лицом', durationMin: 45, price: 3000, color: 'bg-orange-100 text-orange-700', category: 'Лицо' },
];

export const MOCK_MASTER: User = {
  id: 'm1',
  name: 'Анна Мастерова',
  avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&q=80&w=200',
  role: 'MASTER',
  position: 'Топ-стилист',
  rating: 4.9,
};

export const MOCK_EMPLOYEES: User[] = [
  MOCK_MASTER,
  { id: 'm2', name: 'Игорь Бритва', avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&q=80&w=200', role: 'MASTER', position: 'Барбер', rating: 4.8 },
  { id: 'm3', name: 'Светлана Ноготок', avatar: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&q=80&w=200', role: 'MASTER', position: 'Мастер маникюра', rating: 5.0 },
];

export const MOCK_CLIENTS: User[] = [
  { id: 'c1', name: 'Елена Смирнова', avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&q=80&w=200', role: 'CLIENT', phone: '79991234567' },
  { id: 'c2', name: 'Мария Иванова', avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&q=80&w=200', role: 'CLIENT', phone: '79997654321' },
  { id: 'c3', name: 'Дмитрий Петров', avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&q=80&w=200', role: 'CLIENT', phone: '79995554433' },
  { id: 'c4', name: 'Ольга Соколова', avatar: 'https://images.unsplash.com/photo-1554151228-14d9def656ec?auto=format&fit=crop&q=80&w=200', role: 'CLIENT', phone: '79991112233' },
];

export const MOCK_PRODUCTS: Product[] = [
  { id: 'p1', name: 'Шампунь восстанавливающий', category: 'Уход за волосами', stock: 15, unit: 'шт', price: 1200, minStock: 5 },
  { id: 'p2', name: 'Лак для волос сильный', category: 'Стайлинг', stock: 8, unit: 'шт', price: 950, minStock: 10 },
  { id: 'p3', name: 'Краска для волос 7.1', category: 'Расходники', stock: 450, unit: 'мл', price: 3.5, minStock: 100 },
];

export const MOCK_TRANSACTIONS: FinanceTransaction[] = [
  { id: 't1', date: '2024-11-20', amount: 2500, type: 'income', category: 'Услуги', description: 'Стрижка (Елена С.)' },
  { id: 't2', date: '2024-11-20', amount: 800, type: 'expense', category: 'Расходники', description: 'Закупка воска' },
  { id: 't3', date: '2024-11-19', amount: 15000, type: 'income', category: 'Услуги', description: 'Дневная выручка' },
];

export const INITIAL_APPOINTMENTS: Appointment[] = [
  {
    id: 'a1',
    clientId: 'c1',
    clientName: 'Елена Смирнова',
    clientAvatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&q=80&w=200',
    serviceId: 's1',
    serviceName: 'Стрижка и укладка',
    startTime: new Date(new Date().setHours(10, 0, 0, 0)).toISOString(),
    durationMin: 60,
    status: 'confirmed',
    paid: true,
  },
  {
    id: 'a2',
    clientId: 'c2',
    clientName: 'Мария Иванова',
    clientAvatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&q=80&w=200',
    serviceId: 's3',
    serviceName: 'Окрашивание волос',
    startTime: new Date(new Date().setHours(13, 30, 0, 0)).toISOString(),
    durationMin: 120,
    status: 'pending',
    paid: false,
  },
  {
    id: 'a3',
    clientId: 'c3',
    clientName: 'Дмитрий Петров',
    clientAvatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&q=80&w=200',
    serviceId: 's4',
    serviceName: 'Коррекция бровей',
    startTime: new Date(new Date().setHours(16, 0, 0, 0)).toISOString(),
    durationMin: 30,
    status: 'confirmed',
    paid: true,
  },
];
